/*
 * @Author: Src
 * @Date: 2025-03-25 15:36:07
 * @LastEditTime: 2025-05-21 16:55:26
 * @LastEditors: Src
 * @FilePath: /work-station/src/main.ts
 * @Description: 头部注释配置模板
 */
import Vue from 'vue';
import router from './router';
import LocalApp from './LocalApp.vue';
import Antd, { message } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './scss/index.scss';
import components from './components';
// import 'reflect-metadata';
import AmapVue from '@amap/amap-vue';
import uploader from 'vue-simple-uploader';
import directives from './common/directives';
import VueClipboard from 'vue-clipboard2';
import 'viewerjs/dist/viewer.css';
import VueViewer, { directive as viewerDirective } from 'v-viewer';
import store from './store';
// AmapVue.config.version = '2.0'; // 默认2.0，这里可以不修改
AmapVue.config.key = '6f5a626b93850e6e0d46610046818b13';

Vue.config.productionTip = false;

message.config({
  top: '25%',
  duration: 3,
});

Vue.prototype.$message = message;

Vue.use(AmapVue);
Vue.use(Antd);
Vue.use(components);
Vue.use(uploader);
Vue.use(directives);
Vue.use(VueClipboard);
Vue.use(VueViewer);
Vue.directive('viewer', viewerDirective({ debug: true }));

new Vue({
  router,
  store,
  render: (h) => h(LocalApp),
}).$mount('#app');
